import { Upload, X } from 'lucide-react';

const MediaGallerySection = ({ imagePreviewUrls, onFileChange, onRemoveFile }) => {
  return (
    <div className="space-y-2">
      <label className="block text-xs font-bold text-slate-700 tracking-wide mb-1.5">
        Media gallery
      </label>

      <div className="border-2 border-dashed border-slate-200 rounded-2xl p-4 sm:p-6 text-center hover:bg-slate-50 transition-colors relative cursor-pointer">
        <input
          type="file"
          multiple
          accept="image/*"
          onChange={onFileChange}
          className="absolute inset-0 w-full h-full opacity-0 cursor-pointer"
        />
        <Upload size={24} className="mx-auto text-slate-400 mb-2" />
        <p className="text-xs sm:text-sm font-semibold text-slate-600">
          Click or drag images to upload
        </p>
        <p className="text-[10px] sm:text-xs text-slate-400 mt-1">Supports JPG, PNG, WEBP</p>
      </div>

      {imagePreviewUrls && imagePreviewUrls.length > 0 && (
        <div className="grid grid-cols-3 sm:grid-cols-6 md:grid-cols-8 gap-2.5 sm:gap-4 mt-3 sm:mt-4">
          {imagePreviewUrls.map((url, idx) => (
            <div
              key={idx}
              className="relative aspect-square rounded-xl overflow-hidden group shadow-xs border border-slate-100"
            >
              <img src={url} alt="Preview" className="w-full h-full object-cover" />
              <button
                type="button"
                onClick={() => onRemoveFile(idx)}
                className="absolute top-1 right-1 p-1 bg-black/50 text-white rounded-full opacity-0 group-hover:opacity-100 transition-opacity cursor-pointer"
              >
                <X size={12} />
              </button>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default MediaGallerySection;
